import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SessionService } from '../../Services/session.service';
import { EncryptionDecryptionService } from 'src/app/Services/encryption-decryption/encryption-decryption.service';
import { Router, ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { UnitPriceService } from 'src/app/Services/admin-rights/unit-price.service';
import { DashboardFilters, DashboardDetails } from 'src/app/Models/Dashboard/DashboardFilters';
import { MatSnackBarComponent } from "../mat-snack-bar/mat-snack-bar.component";
import { PagerService } from 'src/app/Services/pager.service';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-unit-price',
  templateUrl: './unit-price.component.html',
  styleUrls: ['./unit-price.component.css'],
  providers: [PagerService, DatePipe]
})
export class UnitPriceComponent implements OnInit {
  userName: string;
  roleCode: string;
  userID: string;
  roleID: string;
  unitPriceDetails: any[] = [];
  loader: string = 'none';
  path: string;
  Name: string;
  Date = new Date();
  CurrentDate: string;
  previousYear: number;
  currentYear: number;
  futureYear: number;
  files: File[] = [];
  fileName: string = '';
  pageSetting : number = 10;
  pager : any = {};
  model : any[] = [];
  modalSetting : number = 0;
  modelFilter : any[];
  modelDepandent : any[];
  selectedPaging : any;
  @ViewChild('file') input;


  constructor(private session: SessionService,
    private encryptionDecryptionService: EncryptionDecryptionService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private unitPriceService: UnitPriceService, private snackBar: MatSnackBarComponent,
    private _pagerService: PagerService, private datePipe: DatePipe,private toastr: ToastrService) {
    this.roleID = localStorage.getItem('mcmt_roleID');
    this.userID = localStorage.getItem('mcmt_userId');
    this.selectedPaging = '0';
    this.CurrentDate = this.datePipe.transform(this.Date, 'MM/dd/yyyy');
    this.Name = localStorage.getItem('mcmt_userName');
  }

  ngOnInit(): void {
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
    clearInterval(this.session.id);
    this.session.startSession();
    let today = new Date();
    let year = today.getFullYear();
    this.previousYear = year - 1;
    this.currentYear = year;
    this.futureYear = year + 1;
    this.getUnitPrice();

  }

  getUnitPrice() {
    this.loader = 'block';
    this.unitPriceService.getUnitPrice()
      .subscribe((resdata: any) => {
        if (resdata.status == true) {
          this.unitPriceDetails = resdata.data;
          this.model = resdata.data;
          this.setPage(1, this.pageSetting)
          this.loader = 'none';
        }
        else {
          this.toastr.error(resdata.data.msg);
          this.loader = 'none';
        }
      });
  }

  excelDownload() {
    this.loader = 'block';
    this.unitPriceService.downloadExcel()
      .subscribe(
        success => {
          var date = new Date();
          let latest_date = this.datePipe.transform(date, 'dd-MMM-yy')
          let Name = localStorage.getItem('mcmt_userName').split(' ');
          let Firstname = Name[0];
          let LastName = Name[1];
          let ExcelName = Firstname + '_' + LastName + '_UnitPrice_' + latest_date + '.xlsx';
          saveAs(success, ExcelName);

          this.loader = 'none';
        },
        err => {
          this.toastr.error("No record/s available");
          this.loader = 'none';
        }
      );
  }

  uploadUnitPrice(files: File[]) {
    this.files = [];
    this.files = files;
    let fileNameParts: string[] = files[0].name.split('.');
    let fileType = files[0].name.split('.')[fileNameParts.length - 1];
    if (fileType != 'xls' && fileType != 'xlsx') {
      this.toastr.error('Please Select Valid File Type.');
      this.loader = 'none';
      this.input.nativeElement.value = null;
      return false;
    }

    this.loader = 'block';
    this.unitPriceService.uploadUnitPrice(<File>this.files[0])
      .subscribe((resData: any) => {
        if (resData.status == true) {
          if (resData.data[0].status == 'true') {
            this.toastr.success(resData.data[0].msg);
            this.loader = 'none';
            this.getUnitPrice();
            this.input.nativeElement.value = null;
          } else {
            this.toastr.error(resData.data[0].msg);
            this.loader = 'none';
            this.input.nativeElement.value = null;
          }
        }
        else {
          this.toastr.error('Some problem occurred, please try again later.');
          this.loader = 'none';
          this.input.nativeElement.value = null;
        }
        this.files = [];
        this.loader = 'none';
      });
    this.files = files;
    this.fileName = files[0].name;
  }


  // Start :For Pagination
  setPage(page: number, pageSize: number) {
    // get pager object from service
    if (this.modalSetting == 0) {
      this.pager = this._pagerService.getPager(this.model.length, page, pageSize);
      this.unitPriceDetails = this.model.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
    else {
      if (this.modalSetting == 1) {
        this.pager = this._pagerService.getPager(this.model.length, page, pageSize);
        this.unitPriceDetails = this.model.slice(this.pager.startIndex, this.pager.endIndex + 1);
      }
      else {
        this.pager = this._pagerService.getPager(this.modelDepandent.length, page, pageSize);
        this.unitPriceDetails = this.modelDepandent.slice(this.pager.startIndex, this.pager.endIndex + 1);
      }
    }
    // get current page of items
  }
}
